<template>
  <div class="animated fadeIn">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> Open Compliance Items
            </div>
            <div class="card-block">
              <table class="table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Area</th>
                    <th>Standard</th>
                    <th>Detail</th>
                    <th>Notes</th>
                    <th>Priority</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>The OSHA Blood-Borne Pathogen Regulation</td>
                    <td>ANSI/AAMI 4.5.2</td>
                    <td>3 gaps found</td>
                    <td>Educate personnel working in the decontamination area on decontaminating reusable gloves, glove liners, aprons, and eye-protection devices according to the manufacturer's written IFU's at least daily and between employees.
                        <br>Educate personnel working in the decontamination area on wearing fluid-resistant face masks and eye protection if there is any risk of splash or splatter.
                        <br>Educate staff and make general-purpose utility gloves available.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Mechanical Cleaning</td>
                    <td>ANSI/AAMI 7.5.3.3</td>
                    <td>2 gaps found</td>
                    <td>Create Mechanical equipment cleaning log to monitor quality and preventative maintenance
                        <br>Educate staff on ultrasonic cleaning process</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Presoaking</td>
                    <td>ANSI/AAMI 7.3</td>
                    <td>1 gap found</td>
                    <td>Educate staff on manufacturer's IFU's and make them available for use.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Record Keeping</td>
                    <td>ANSI/AAMI 3.3.7.1</td>
                    <td>1 gap found</td>
                    <td>Create space for record keeping.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Rinsing</td>
                    <td>ANSI/AAMI 7.5.5</td>
                    <td>1 gap found</td>
                    <td>In service staff on rinsing methods.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Sinks</td>
                    <td>ANSI/AAMI 3.3.7.1</td>
                    <td>7 gaps found</td>
                    <td>Create a plan to get a source of deionized, distilled, or reverse osmosis (RO) water for final rinsing.
                        <br>Make foot stools readily available to accommodate shorter employees.
                        <br>Create a plan to measure cleaning solution in washing sink.
                        <br>Create a plan to measure water levels in sinks.
                        <br>Create a plant to get a high-pressure water gun.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-down"></i></button><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Cleaning</td>
                    <td>ANSI/AAMI 7.5.3.2</td>
                    <td>4 gaps found</td>
                    <td>Document the temperature of the soaking solution.
                        <br>Educate staff on manual cleaning of delicate or complex medical devices.
                        <br>Educate staff on where and how to read manufacturer's written IFU.
                        <br>Monitor the temperature of the soaking solution.</td>
                    <td><button type="button" class="btn btn-outline-primary"><i class="fa fa-caret-up"></i></button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination">
                  <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                  <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item"><a class="page-link" href="#">4</a></li>
                  <li class="page-item"><a class="page-link" href="#">Next</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div><!--/.col-->
      </div><!--/.row-->
  </div>
</template>
<script>
export default {
  name: 'open-compliance'
}
</script>
